/* React */
import React from "react";

/* Ionic */
import { IonIcon } from "@ionic/react";

import {
  gitBranch,
  chevronDown,
  chevronUp,
  trash,
} from "ionicons/icons";

/* Utils */
import { isSegment } from "src/utils/guards/customCohorts";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Constants */
import { Operator } from "src/shared/interfaces/custom-cohorts/Operator";

/* Stylesheet */
import styles from "./SegmentToolbar.module.scss";

/* Interfaces */
import {
  BasicProps,
  LogicalProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface SegmentToolbarProps {
  indexPath: number[];
  segments: BasicProps | LogicalProps;
  label?: string;
  disabled: boolean;
  showContent: boolean;
  setShowContent: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  handleDeleteSegment: (indexPath: number[]) => void;
}

const SegmentToolbar: React.FC<SegmentToolbarProps> = ({
  indexPath,
  segments,
  label,
  disabled,
  showContent,
  setShowContent,
  handleDeleteSegment,
}) => {
  return (
    <div
      style={{
        padding: isSegment(segments)
          ? "0px 12px 0px 0px"
          : "0px 12px 0px 21px",
      }}
      className={styles.segment_toolbar}
    >
      <div
        style={{
          background: isSegment(segments)
            ? segments.operator === Operator.AND
              ? "var(--ion-color-primary)"
              : "var(--ion-color-secondary)"
            : "transparent",
        }}
        className={`${styles.label_container} ${
          isSegment(segments)
            ? styles.logical_label
            : undefined
        }`}
      >
        {isSegment(segments) ? (
          <IonIcon
            className={styles.icon}
            icon={gitBranch}
          />
        ) : undefined}
        <div
          style={{
            color: disabled
              ? "var(--ion-color-text-disabled)"
              : "var(--ion-color-text-primary)",
            textTransform: isSegment(segments)
              ? "uppercase"
              : "none",
          }}
          className={styles.label}
        >
          {label}
        </div>
      </div>
      <div className={styles.button_container}>
        {segments ? (
          <PrimaryFabButton
            scssProps={{
              color: "var(--ion-color-text-tertiary)",
              background: "transparent",
            }}
            className={"small"}
            ariaLabel={"delete"}
            icon={trash}
            disabled={disabled}
            onClick={() => handleDeleteSegment(indexPath)}
          />
        ) : undefined}
        <PrimaryFabButton
          scssProps={{
            color: "var(--ion-color-text-tertiary)",
            background: "transparent",
          }}
          className={"small"}
          ariaLabel={"toggle"}
          icon={showContent ? chevronUp : chevronDown}
          disabled={disabled}
          onClick={() => setShowContent((prev) => !prev)}
        />
      </div>
    </div>
  );
};

export default SegmentToolbar;
